import {Component, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
import {LigneLivraisonImpossibleDTO} from '../../../../core/dtos/gestion-fournisseur/ligne-livraison-impossible-dto';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {SharedModule} from '../../../../shared/shared.module';
import {Workbook} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {saveAs} from 'file-saver';

@Component({
  selector: 'yo-livraison-impossible-popup',
  templateUrl: './livraison-impossible-popup.component.html',
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxDataGridModule, SharedModule]
})
export class LivraisonImpossiblePopupComponent {

  visible = input(false);
  livraisonImpossibleList = input<LigneLivraisonImpossibleDTO[]>([]);
  closed = output();

  readonly ButtonThemeEnum = ButtonThemeEnum;

  close(): void {
    this.closed.emit();
  }

  onExporting = (e: any): void => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Articles non commandés');
    exportDataGrid({component: e.component, worksheet, autoFilterEnabled: true}).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'articles-non-commandes.xlsx');
      });
    });
    e.cancel = true;
  }
}
